import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import './styles.css';

const LinkButton = ({
  target = null,
  text = 'caption',
  link,
  to = '',
  controlFunc,
  btnFontSize = '0.9286rem',
  btnFontWeight = 700,
  btnFontFamily = 'Poppins',
  btnTextColor = '#17377d',
  btnHoverColor = '#f40',
  btnStyles,
  underline = true,
  title,
}) => {
  const [hover, setHover] = useState(false);

  const hoverOn = () => {
    setHover(true);
  };

  const hoverOff = () => {
    setHover(false);
  };

  const linkButtonColor = hover ? btnHoverColor : btnTextColor;

  const linkButtonStyles = {
    color: linkButtonColor,
    boxShadow: underline
      ? `inset 0 -2px 0 0 #fff, inset 0 -3px 0 0 ${linkButtonColor}`
      : 'none',
    fontFamily: `${btnFontFamily}, sans-serif`,
    fontWeight: btnFontWeight,
    fontSize: btnFontSize,
    ...btnStyles,
  };

  const asLink = link ? (
    <a
      target={target}
      href={link}
      className="link-button link-button--link"
      onMouseEnter={hoverOn}
      onMouseLeave={hoverOff}
      onFocus={hoverOn}
      onBlur={hoverOff}
      style={linkButtonStyles}
      title={title}
      onClick={controlFunc}
    >
      {text}
    </a>
  ) : (
    <NavLink
      target={target}
      to={to}
      className="link-button link-button--link"
      onMouseEnter={hoverOn}
      onMouseLeave={hoverOff}
      onFocus={hoverOn}
      onBlur={hoverOff}
      style={linkButtonStyles}
      onClick={controlFunc}
    >
      {text}
    </NavLink>
  );

  const asButton = (
    <button
      className="link-button link-button--button"
      onClick={controlFunc}
      onMouseEnter={hoverOn}
      onMouseLeave={hoverOff}
      onFocus={hoverOn}
      onBlur={hoverOff}
      style={linkButtonStyles}
      type="button"
      title={title}
    >
      {text}
    </button>
  );

  return <>{link || to ? asLink : asButton}</>;
};

LinkButton.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  link: PropTypes.string,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  controlFunc: PropTypes.func,
  btnFontFamily: PropTypes.string,
  btnFontSize: PropTypes.string,
  btnFontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  btnTextColor: PropTypes.string,
  btnHoverColor: PropTypes.string,
};

export default LinkButton;
